export default {
  namespaced: true,

  // initial state
  state: {
    windowWidth: window.innerWidth
  },

  //mutations
  mutations: {
    setWindowWidth(state, width) {
      state.windowWidth = width;
    }
  },

  //actions
  actions: {},

  //getters
  getters: {
    windowWidth: state => state.windowWidth
  }
};
